/**
 * Rutas de las pantallas de impresoras. Separado de `impresoraRoutes.tsx` para que las vistas lo
 * importen (breadcrumb, navegación) sin dependencia circular con la carga diferida de las vistas.
 * `action` es el permiso de la sección (SecurityContext).
 */
export const impresoraRoutesMap = {
  gestion: {
    path: '/impresoras/gestion',
    name: 'Impresoras',
    action: 'GESTION_DE_IMPRESORAS',
  },
  documentos: {
    path: '/impresoras/documentos',
    name: 'Impresoras por Documento',
    action: 'GESTION_DE_IMPRESORAS',
  },
}
